<template>
  <div>
    <v-container>
      <div class="text-xs-right mb-2">
        <v-btn class="ma-0 mb-1" color="grey" outline @click="exportData">
          <em class="fas fa-file-export mr-1" />
          {{ $t('export') }}
        </v-btn>
      </div>
      <div>
        <DateFilter
          v-model="selectedDate"
          :default-filter="'today'"
          :show-time="true"
          @changeDate="getData"
        ></DateFilter>
      </div>
      <div class="my-3">
        <v-card class="pa-3">
          <v-layout wrap>
            <v-flex class="text-xs-left" xs6>
              <template
                v-if="
                  [
                    '109154847972476',
                    '109181747969457',
                    '178737485661189',
                    '608979672643642'
                  ].includes(selectedBot.pageid)
                "
              >
                <Multiselect
                  v-model="filter.page"
                  :allow-empty="false"
                  :options="pageOptions"
                  :show-labels="false"
                  label="text"
                  placeholder="เลือกเพจ"
                  track-by="value"
                  @input="onFilterPage($event)"
                ></Multiselect>
              </template>
            </v-flex>
            <v-flex class="text-xs-right" xs6>
              Total:
              <span class="primary--text" style="font-weight: 600; font-size: 20px">
                {{ data.length }}
              </span>
            </v-flex>
          </v-layout>
        </v-card>
      </div>
      <v-data-table
        :headers="filteredHeader"
        :items="data"
        :loading="loading"
        :pagination.sync="pagination"
        class="elevation-1"
        hide-actions
      >
        <template #items="props">
          <td>
            <v-avatar size="30">
              <img
                v-if="props.item.profile_pic"
                :alt="props.item.first_name + ' ' + props.item.last_name"
                :src="props.item.profile_pic"
                height="30"
                width="30"
              />
              <img
                v-else
                :alt="props.item.first_name + ' ' + props.item.last_name"
                :src="'/static/img/assets/livechat/profile.png'"
                height="30"
                width="30"
              />
            </v-avatar>
          </td>
          <td
            :title="
              (props.item.first_name ? props.item.first_name : '') +
              ' ' +
              (props.item.last_name ? props.item.last_name : '')
            "
            style="min-width: 300px"
          >
            <div style="display: inline-block; vertical-align: top; margin-top: 5px">
              {{
                ((props.item.first_name ? props.item.first_name : '') +
                  ' ' +
                  (props.item.last_name ? props.item.last_name : ''))
                  | truncate(35)
              }}
            </div>
          </td>

          <td>{{ props.item.cardnumber ? $t(props.item.cardnumber) : '-' }}</td>
          <td>{{ props.item.realname ? $t(props.item.realname) : '-' }}</td>
          <td>{{ props.item.address ? $t(props.item.address) : '-' }}</td>
          <td class="text-xs-center">
            {{
              props.item.timestamp ? getFormatDate(props.item.timestamp, 'DD/MM/YYYY HH:mm') : '-'
            }}
          </td>
          <td class="text-xs-center">
            <span v-if="props.item.app == 'facebook'" style="color: #3b5998">
              <em class="fab fa-facebook-square" />
            </span>
            <span v-else-if="props.item.app == 'line'" style="color: #00c300">
              <em class="fab fa-line" />
            </span>
          </td>
          <td>{{ props.item.gender ? $t(props.item.gender) : '-' }}</td>

          <td class="text-xs-center">
            {{ props.item.email ? props.item.email : '-' }}
          </td>
          <td class="text-xs-center">
            {{ props.item.phoneno ? props.item.phoneno : '-' }}
          </td>
          <td class="text-xs-center">
            {{ props.item.status ? props.item.status : '-' }}
          </td>
          <td class="text-xs-center" style="white-space: nowrap">
            <template v-if="userLocale(props.item)">
              <flag :iso="userLocale(props.item).icon" />
            </template>
            <template v-else>-</template>
          </td>
        </template>

        <div slot="no-data" class="text-xs-center">{{ $t('No customer') }}</div>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import api from '@/api'
import moment from 'moment'
import { mapGetters } from 'vuex'
import DateFilter from './../DateFilter.vue'
import config from '@/config'
import Multiselect from 'vue-multiselect'
import { PAGE_SCG_LIVE } from '../../../../constants/scg_live'

export default {
  components: {
    DateFilter,
    Multiselect
  },
  data() {
    return {
      pagination: { rowsPerPage: -1, sortBy: '' },
      loading: false,
      data: [],
      selectedDate: {
        start: moment().format('YYYY-MM-DD 00:00'),
        end: moment().format('YYYY-MM-DD 23:59')
      },
      filter: {
        page: ''
      },
      pageOptions: [
        {
          text: 'All',
          value: ''
        },
        ...PAGE_SCG_LIVE
      ]
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    filteredHeader() {
      var header = [
        { text: '', sortable: false },
        { text: this.$t('name'), value: 'first_name' },
        { text: this.$t('Shop code'), value: 'cardnumber' },
        { text: this.$t('Shop name'), value: 'realname' },
        { text: this.$t('Province'), value: 'address' },
        { text: this.$t('เวลา Check-in'), value: 'timestamp' },
        { text: this.$t('Channel'), value: 'app' },
        { text: this.$t('gender'), value: 'gender' },

        { text: this.$t('Email'), value: 'email' },
        { text: this.$t('phone no.'), value: 'phoneno' },
        { text: this.$t('Status'), value: 'status' },

        { text: this.$t('Locale'), value: 'locale' }
      ]
      return header
    }
  },
  async mounted() {
    if (
      ['109154847972476', '109181747969457', '178737485661189', '608979672643642'].includes(
        this.selectedBot.pageid
      )
    ) {
      var currentPage = this.pageOptions.find((el) => {
        if (el.value == this.selectedBot.pageid) {
          return el
        }
      })

      this.filter.page = currentPage
    }
    await this.getData()
  },
  methods: {
    userLocale: function (item) {
      return config.locale.find(function (locale) {
        if (item.locale == locale.value) {
          return locale.title
        }
      })
    },
    getFormatDate: function (date, format) {
      return moment(date).format(format)
    },
    getData() {
      return new Promise((resolve) => {
        this.loading = true
        var pageid = ''
        if (
          ['109154847972476', '109181747969457', '178737485661189', '608979672643642'].includes(
            this.selectedBot.pageid
          )
        ) {
          //Chang Family Live Fair
          pageid = ''
          if (this.filter.page) {
            pageid = this.filter.page.value
          } else {
            pageid = this.selectedBot.pageid
          }
        } else {
          pageid = this.selectedBot.pageid
        }
        var data = {
          pageid: pageid,
          startdate: this.selectedDate.start,
          enddate: this.selectedDate.end
        }
        api.scgdistributiongetinterestusers(data, (err, response) => {
          this.data = response.data
          this.loading = false
          resolve()
        })
      })
    },
    exportData: function () {
      let vm = this
      if (vm.loading) {
        return false
      }

      var csvdata =
        'Name,Shop code,Shop name,Province,เวลา Check-in,Channel,Gender,Email,Phone no.,Status,Locale\r\n'

      this.data.forEach((el) => {
        csvdata += `${el.first_name ? el.first_name + ` ${el.last_name}` : '-'},${
          el.cardnumber ? el.cardnumber : '-'
        },${el.realname ? el.realname : '-'},${
          el.address ? vm.escapeCsvValue(el.address.replaceAll(',', '')) : '-'
        },${el.timestamp ? moment(el.timestamp).format('YYYY-MM-DD HH:mm') : '-'},${
          el.app ? el.app : '-'
        },${el.gender ? el.gender : '-'},${el.email ? el.email : '-'},${
          el.phoneno ? el.phoneno : '-'
        },${el.status ? el.status : '-'},${el.locale ? el.locale : '-'}\r\n`
      })
      vm.exportCsv(csvdata, 'cartsummary')
    },
    onFilterPage(page) {
      this.filter.page = page
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/customize/ScgdistributionInterest.vue